/**
 * Form controls for brand surfaces (brand/BRAND.md §9): one field, one label,
 * one error, shared by every brand form so the contact page and the auth
 * routes cannot drift apart.
 *
 * Fields are `ss-sunken` insets: they sit inside white cards
 * (`bg-ss-surface`), and sunken is the one ground for insets. Errors are the
 * loud tint with loud ink — coral is for problems (§4). Labels are `ss-small`,
 * bold for emphasis, in slate.
 */

export const brandFieldClass =
  'ss-body w-full rounded-ss-s border border-ss-line bg-ss-sunken px-4 py-3 text-ss-ink ' +
  'placeholder:text-ss-slate transition-colors duration-[var(--ss-dur-fast)] ease-ss-out ' +
  'focus:border-ss-ink focus:outline-none'

export const brandFieldLabelClass = 'ss-small mb-1.5 block font-bold text-ss-slate'

export const brandFieldErrorClass =
  'ss-small rounded-ss-s bg-ss-loud-tint px-3 py-2 font-bold text-ss-loud-ink'
